import React from "react"
import CustomImage from "@/main/customImage"
import { useDispatch } from "react-redux"

import { Col, Card, Button } from "react-bootstrap"

import {
    toggleRequestViewingModal,
    setRequestViewingProperty,
} from "@/slices/requestViewingModalSlice"

function InterestedCard({ property }) {
    const dispatch = useDispatch()
    return (
        <Col xs={12} as={Card} className="sticky-top-scroll mt-5">
            {/* Interested Card */}
            <div className="interested-img-div align-middle w-100">
                <CustomImage
                    src={
                        property.images[0]?.imgix_url ||
                        "https://webb-jenkins-static-164679926.imgix.net/placeholder.svg"
                    }
                    alt={`Property ${property.property_ref} main`}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                    sizes="50vw"
                />
            </div>

            <Card.Body>
                <Card.Title>
                    <h2>Interested in this property?</h2>
                </Card.Title>
                <Card.Text as={Col}>
                    <h3 className="h6">Find us in branch</h3>
                    <ul className="card-address">
                        <li className="card-address">
                            <span>
                                Suite 18, Salisbury Gardens, Dudley Rd, Ventnor,
                                IOW PO38 1EJ
                            </span>
                        </li>
                    </ul>

                    <h3 className="h6 mt-3">Or contact us remotely</h3>
                    <ul className="card-email mb-3">
                        <li className="card-email">
                            <span>
                                {property.trans_type_id === 1 && "sales"}
                                {property.trans_type_id === 2 && "rentals"}
                                @webbjenkins.co.uk
                            </span>
                        </li>
                    </ul>

                    <ul className="card-number mb-4">
                        <li className="card-number">
                            <a href="tel:01983 856111" role="button">
                                <span>01983 856111</span>
                            </a>
                        </li>
                    </ul>
                    <Col
                        xs={12}
                        as={Button}
                        variant="outline-warning"
                        size="lg"
                        className="px-3 mt-1 rounded-0 "
                        onClick={() => {
                            dispatch(toggleRequestViewingModal(true))
                            dispatch(setRequestViewingProperty(property))
                        }}
                        style={{
                            background: "white",
                        }}
                    >
                        <span className="m-0 d-inline text-warning">
                            Request a viewing
                        </span>
                    </Col>
                </Card.Text>
            </Card.Body>
            {/* Interested Card End */}
        </Col>
    )
}

export default InterestedCard
